function calculatePublicationCountdown() {
  const publishDateElement = document.getElementById("OHM-PRODUCT-PUBLICATION-DATE");
  const countdownDisplayElement = document.getElementById("countdown-displayUS");

  if (!publishDateElement || !countdownDisplayElement) {
    console.error("One or more required HTML elements for the countdown are missing.");
    return;
  }

  const publish_date_timestamp = parseInt(publishDateElement.innerText);

  if (isNaN(publish_date_timestamp)) {
    console.error("Invalid publication date. Please ensure 'OHM-PRODUCT-PUBLICATION-DATE' contains a valid timestamp.");
    return;
  }

  let countdownInterval;

  const updateCountdown = () => {
    const date_now = Math.floor(Date.now() / 1000);
    const time_remaining = publish_date_timestamp - date_now;

    if (time_remaining > 0) {
      const days = Math.floor(time_remaining / 86400);
      const hours = Math.floor((time_remaining % 86400) / 3600);
      const minutes = Math.floor((time_remaining % 3600) / 60);
      const seconds = Math.floor(time_remaining % 60);

      const formattedTime =
        `${String(days).padStart(2, '0')}:` +
        `${String(hours).padStart(2, '0')}:` +
        `${String(minutes).padStart(2, '0')}:` +
        `${String(seconds).padStart(2, '0')}`;
      
      countdownDisplayElement.innerHTML = formattedTime;
    }
  };
  updateCountdown();

  countdownInterval = setInterval(updateCountdown, 1000);
}
document.addEventListener('DOMContentLoaded', calculatePublicationCountdown);


// function calculatePublicationCountdown() {
//   const publish_date = document.getElementById("OHM-PRODUCT-PUBLICATION-DATE").innerHTML;

//   if(publish_date) {
//     let date_now = Math.floor(Date.now() / 1000);
//     let time_remaining =  parseInt(publish_date) - date_now;
    
//     if(time_remaining > 0) {
//       setInterval(function () {
//           date_now = (Date.now()/1000);
//           time_remaining = publish_date - date_now;
//           const days = Math.floor(time_remaining/86400) || 0;
//           const hours = Math.floor((time_remaining / 3600) % 24) || 0;
//           const minutes = Math.floor((time_remaining % 3600) / 60) || 0;
//           const seconds = Math.floor(time_remaining % 60) || 0;

//           `${days.toString().padStart(2, '0')}:${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
//       }, 1000);

//       document.getElementById('STUDIO-SEIZH-OPEN-RESTOCK-FORM').innerHTML = 'Join the Waitlist & Receive a Special Offer';
//     }
//   }
// }

// calculatePublicationCountdown();